import { FC } from 'react';

interface ISvg {
	spriteUrl: string;
	className?: string;
	onClick?: () => void;
}

/**
 * Renders an SVG icon from a sprite sheet using the `<use>` element.
 *
 * The sprite file must export icons with the fragment ID `#icon`.
 * This is the standard icon primitive used throughout the application.
 *
 * @param spriteUrl - Path to the SVG sprite file (e.g. imported via `import icon from 'assets/icons/Close.svg'`).
 * @param className - Optional CSS class for sizing and colour overrides.
 * @param onClick - Optional click handler.
 *
 * @example
 * import closeIcon from 'assets/icons/Close.svg';
 * <SvgIcon spriteUrl={closeIcon} className={styles.icon} onClick={handleClose} />
 */
const SvgIcon: FC<ISvg> = ({ spriteUrl, className, ...props }) => {
	return (
		<svg className={className} {...props}>
			<use href={`${spriteUrl}#icon`} />
		</svg>
	);
};

export default SvgIcon;
